export const SHADOW_APP_ID = 'shadow-app';
export const SHADOW_APP_PORTAL_ID = 'shadow-app-sibling';
export const SHADOW_HOST_ID = 'shadow-host';

export const shadowRoot = () =>
  document.getElementById(SHADOW_HOST_ID)?.shadowRoot;
